import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-show-more',
  styleUrls: ['./show-more.component.scss'],
  templateUrl: './show-more.component.html',
})
export class ShowMoreComponent {
  @Output()
  public showEvent: EventEmitter<void> = new EventEmitter<void>();

  public toggled = false;

  public toggle(): void {
    this.toggled = !this.toggled;
    if (this.toggled) {
      this.showEvent.emit();
    }
  }
}
